import React from "react";
import { motion } from "framer-motion";

// --- ASSETS & CONFIG ---
// You can replace these with imports if you have a separate config file
const SPLASH_CAR_IMAGE = "car-full.png";
// const SPLASH_CAR_IMAGE =
//   "https://images.unsplash.com/photo-1494976388531-d1058494cdd8?q=80&w=2070&auto=format&fit=crop";
const LOGO_TEXT = "FOKAL";

// Theme colors needed for the loading bar
const THEME_PRIMARY = "#dc2626";

const SplashScreen = ({ onComplete }) => {
  return (
    <motion.div
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1, ease: "easeInOut" }}
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "#000", // Pitch black start
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      {/* Background Car Image - Starts invisible, then lights up */}
      <motion.div
        initial={{ opacity: 0, scale: 1.1 }}
        animate={{ opacity: 0.6, scale: 1 }}
        transition={{ delay: 0.5, duration: 2, ease: "easeOut" }}
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${SPLASH_CAR_IMAGE})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "contrast(1.2) brightness(0.8)",
        }}
      />

      {/* Headlight Effect Container */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "450px",
        }}
      >
        {/* Left Headlight */}
        <motion.div
          initial={{ opacity: 0, scale: 0 }}
          animate={{
            opacity: [0, 1, 0.5, 1], // Flicker effect
            scale: [0.5, 1.2, 1],
          }}
          transition={{ duration: 1.5, times: [0, 0.2, 0.3, 1] }}
          style={{
            width: "200px",
            height: "200px",
            background:
              "radial-gradient(circle, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 70%)",
            filter: "blur(40px)",
            mixBlendMode: "screen",
          }}
        />

        {/* Right Headlight */}
        <motion.div
          initial={{ opacity: 0, scale: 0 }}
          animate={{
            opacity: [0, 1, 0.5, 1], // Flicker effect
            scale: [0.5, 1.2, 1],
          }}
          transition={{ duration: 1.5, times: [0, 0.2, 0.3, 1] }}
          style={{
            width: "200px",
            height: "200px",
            background:
              "radial-gradient(circle, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 70%)",
            filter: "blur(40px)",
            mixBlendMode: "screen",
          }}
        />
      </div>

      {/* Center Text with Shine Effect */}
      <div style={{ position: "relative", zIndex: 20 }}>
        <motion.h1
          initial={{ opacity: 0, letterSpacing: "1em" }}
          animate={{ opacity: 1, letterSpacing: "0.2em" }}
          transition={{ delay: 1.2, duration: 1.5, ease: "easeOut" }}
          style={{
            fontSize: "clamp(40px, 10vw, 120px)",
            fontWeight: 900,
            color: "white",
            textTransform: "uppercase",
            fontFamily: "sans-serif",
            margin: 0,
            position: "relative",
            // Simple metallic gradient text
            background:
              "linear-gradient(to bottom, #ffffff 0%, #a1a1aa 50%, #ffffff 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            filter: "drop-shadow(0 0 20px rgba(255,255,255,0.5))",
          }}
        >
          {LOGO_TEXT}
        </motion.h1>
      </div>

      {/* Bottom Loading Bar */}
      <motion.div
        initial={{ width: 0 }}
        animate={{ width: "200px" }}
        onAnimationComplete={onComplete}
        transition={{ delay: 0.5, duration: 2.5 }}
        style={{
          position: "absolute",
          bottom: "50px",
          height: "2px",
          backgroundColor: THEME_PRIMARY,
          zIndex: 20,
        }}
      />
    </motion.div>
  );
};

export default SplashScreen;
